import { useToast } from "@/components/ui/use-toast";
import { useInitiatePasswordRecoveryLink } from "@/features/recover-password/useInitiatePasswordRecovery";
import VerifyPhone from "../Home/card/view/_components/VerifyPhone";
import { useState } from "react";
import EnterPhoneCode from "../Home/card/view/_components/EnterPhoneCode";
import { useVerifyCode } from "@/features/recover-password/useVerifyCode";
import { useNavigate } from "@tanstack/react-router";

const PasswordRecoveryPage = () => {
	const { toast } = useToast();
	const passwordRecoveryMutation = useInitiatePasswordRecoveryLink();
	const verifyCodeMutation = useVerifyCode();
	const [phone, setPhone] = useState<string | null>(null);
	const [countryCode, setCountryCode] = useState<number | null>(null);
	const navigate = useNavigate();
	const [code, setCode] = useState<string>("");

	const handleSubmit = (phone: string, countryCode: number) => {
		setPhone(phone);
		setCountryCode(countryCode);
		passwordRecoveryMutation.mutate(
			{
				phone,
				phone_global_country_id: countryCode,
			},
			{
				onSuccess: (data) => {
					toast({
						title: data.message,
						description: "",
					});
				},
				onError: (error) => {
					toast({
						title: "Request Failed",
						description: error.message,
						variant: "destructive",
					});
				},
			},
		);
	};

	const handleSubmitCode = (code: number) => {
		if (passwordRecoveryMutation.isSuccess) {
			verifyCodeMutation.mutate(
				{
					code: code.toString(),
					guest_id: passwordRecoveryMutation.data.guest_id,
				},
				{
					onSuccess: (data) => {
						navigate({
							to: "/reset-password",
							search: { token: data.access_token },
						});
					},
					onError: (error) => {
						toast({
							title: "Request Failed",
							description: error.message,
							variant: "destructive",
						});
						setCode("");
					},
				},
			);
		}
	};

	const handleResendCode = () => {
		if (!phone || !countryCode) return;
		handleSubmit(phone, countryCode);
	};

	if (passwordRecoveryMutation.isSuccess) {
		return (
			<EnterPhoneCode
				phone={phone ?? ""}
				code={code}
				setCode={setCode}
				onSubmit={handleSubmitCode}
				onResendCode={handleResendCode}
				submitMutationStatus={verifyCodeMutation.status}
				resendMutationStatus={passwordRecoveryMutation.status}
			/>
		);
	}

	return (
		<VerifyPhone
			onSubmit={handleSubmit}
			submitMutationStatus={passwordRecoveryMutation.status}
		/>
	);
};

export default PasswordRecoveryPage;
